import React, { useContext } from "react";
import style from "./index.module.scss";
import { useHistory } from "react-router-dom";
import { Button, Icon, message, Tooltip } from "antd";
import { BiUndo } from "react-icons/bi";
import CountDown from "components/CourseComponents/CountDown";
import useModalHandler from "utils/useModalHandler";
import SettingModal from "components/CourseComponents/Vote/SettingModal";
import { CourseContext } from "../../../Store";
import {
    endVote,
    exportVote,
    getVotePaperContent,
    VoteContent,
    VoteState
} from "service/vote";
import usePromiseCallback from "utils/usePromiseCallback";
import moment from "moment";
import { renderValidityTime } from "../../../../../utils/common";
import { errorMessage } from "../../../../../service/service";

interface VoteHeaderProps {
    data: VoteContent | null;
    onChange: () => void;
    onCountDown: () => void;
}

export default function VoteHeader({
    data,
    onChange,
    onCountDown
}: VoteHeaderProps) {
    const history = useHistory();
    const modal = useModalHandler();
    const { course, basename } = useContext(CourseContext);

    function gotoDetail(voteId: number) {
        history.push(`${basename}/vote/${voteId}`);
    }

    const handleEndVote = usePromiseCallback(async function (
        showError: boolean = true
    ) {
        if (!data) return;

        try {
            const detail = await getVotePaperContent(data.id);
            if (detail.validityTime === data.validityTime)
                await endVote(data.id);
        } catch (e) {
            if (showError) message.error(errorMessage(e));
        } finally {
            onChange();
        }
    });

    function onVoteOk() {
        modal.close();
        onChange();
    }

    return (
        <div className={style.root}>
            <div className={style.wrapper}>
                <div className={style.left}>
                    <h1 className={style.title}>
                        <Tooltip title={data?.title} placement="bottomLeft">
                            <span>{data?.title}</span>
                        </Tooltip>

                        <Button
                            className={style.back}
                            onClick={() => history.goBack()}>
                            <BiUndo size={16} /> 返回
                        </Button>
                    </h1>

                    <div className={style.info}>
                        选项数量 {data?.answersNumber}｜ 活动时长{" "}
                        {renderValidityTime(data?.validityTime)}
                        {data?.startTime && (
                            <span>
                                ｜ 开始时间{" "}
                                {moment(data?.startTime).format("MM-DD HH:mm")}
                            </span>
                        )}
                        {data?.endTime && (
                            <span>
                                &nbsp;&nbsp;&nbsp;结束时间{" "}
                                {moment(data?.endTime).format("MM-DD HH:mm")}
                            </span>
                        )}
                    </div>
                </div>

                <div className={style.right}>
                    {data?.status === VoteState.InProgress && (
                        <CountDown
                            startTime={data.startTime}
                            validityTime={data.validityTime}
                            onEnd={() => handleEndVote(false)}
                            onCountDown={onCountDown}
                        />
                    )}
                    {data?.status === VoteState.InProgress && (
                        <button
                            className={style.settingBtn}
                            onClick={modal.open}>
                            <Icon type="setting" />
                        </button>
                    )}
                    {data?.status === VoteState.InProgress && (
                        <Button
                            type="primary"
                            ghost
                            className={style.button}
                            onClick={handleEndVote}>
                            <Icon type="poweroff" /> 结束投票
                        </Button>
                    )}

                    {data?.status === VoteState.Done && (
                        <span className={style.percent}>
                            参与率 {data.percentage}
                        </span>
                    )}
                    {data?.status === VoteState.Done && (
                        <Button
                            type="primary"
                            ghost
                            className={style.button}
                            onClick={() => exportVote(data.id)}>
                            <Icon type="cloud-download" /> 导出数据
                        </Button>
                    )}
                </div>
            </div>

            <SettingModal
                id={data?.id}
                visible={modal.visible}
                onCancel={modal.close}
                onOk={onVoteOk}
                onShowVote={gotoDetail}
                weekTimeId={course.weekTimeId}
            />
        </div>
    );
}
